import styled from 'styled-components';
import { MIN_CARD_WIDTH } from '@/components/AdCard/AdCard.constants';
import { SIDE_PADDING } from '@/components/AdCards/AdCards.constants';

export const Box = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(${MIN_CARD_WIDTH}px, 1fr));
  justify-content: center;
  gap: 15px 13px;

  @media (max-width: 330px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(auto-fill, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }
`;

export const BannerBox = styled.div`
  grid-column: 1/-1;
  width: calc(100% + ${SIDE_PADDING * 2}px);
  margin-left: -${SIDE_PADDING}px;
`;

export const DesktopBannerBox = styled.div`
  display: flex;
  justify-content: center;
  grid-column: 1/-1;
  width: 100%;
  border-radius: 14px;
  overflow: hidden;
`;
